import MoreVertIcon from "@material-ui/icons/MoreVert";

const DynamicCouponsQrPage = () => {
  const tableHaders = ["Coupon names", "Type", "Store name", "Coupons created", "Used/Available", "Actions"];
  const tableData = [
    {
      couponName: "Coupon_name_1",
      Type: "Shopify",
      StoreName: "Store 1",
      CouponsCreated: "25,000",
      UsedAvailable: "24,000/unlimited",
      Actions: <MoreVertIcon />,
    },
  ];
  return (
    <div className="p-5 bg-[#F9F9FF]">
      <div className="flex justify-between items-center">
        <h1 className="text-[#011533] text-[32px] font-extrabold">Select or create variable</h1>

        <button className=" my-auto bg-[#EE4360] text-white text-base font-bold  py-2 px-7 rounded-[16px]">
          <span className="text-[24px] align-middle mr-1">+</span> Create coupons
        </button>
      </div>
      <div>
        <div className="grid grid-cols-6 gap-14 p-4">
          {tableHaders.map((header) => (
            <div key={header} className="text-[#011533] text-[14px] font-bold text-center m-auto">
              {header}
            </div>
          ))}
        </div>

        <div className="bg-white p-4">
          {tableData.map((data, index) => (
            <div key={index} className="grid grid-cols-6 gap-14 ">
              <div className="text-[#011533] text-[14px] m-auto">{data.couponName}</div>
              <div className="text-[#011533] text-[14px] m-auto">{data.Type}</div>
              <div className="text-[#011533] text-[14px] m-auto">{data.StoreName}</div>
              <div className="text-[#011533] text-[14px] m-auto">{data.CouponsCreated}</div>
              <div className="text-[#011533] text-[14px] m-auto">{data.UsedAvailable}</div>
              <div className="text-[#011533] text-[14px] m-auto">{data.Actions}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DynamicCouponsQrPage;
